var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifeStyleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7902 4.38996L9.79022 14.39C9.40022 14.78 8.77022 14.78 8.38022 14.39L5.55022 11.56C5.16022 11.17 5.16022 10.54 5.55022 10.15C5.94022 9.75996 6.57022 9.75996 6.96022 10.15L9.08022 12.27L18.3702 2.97996C18.7602 2.58996 19.3902 2.58996 19.7802 2.97996C20.1802 3.36996 20.1802 3.99996 19.7902 4.38996ZM14.2702 1.23996C12.5802 0.549959 10.6602 0.309959 8.66022 0.669959C4.59022 1.39996 1.34022 4.67996 0.650221 8.74996C-0.489779 15.5 5.13022 21.28 11.8402 20.41C15.8002 19.9 19.1202 16.95 20.1602 13.1C20.5602 11.63 20.6002 10.21 20.3702 8.87996C20.2402 8.07996 19.2502 7.76996 18.6702 8.33996C18.4402 8.56996 18.3402 8.90996 18.4002 9.22996C18.6202 10.56 18.5202 11.98 17.8802 13.49C16.7202 16.2 14.2002 18.19 11.2702 18.46C6.17022 18.93 1.94022 14.61 2.57022 9.47996C3.00022 5.93996 5.85022 3.05996 9.38022 2.56996C11.1102 2.32996 12.7502 2.65996 14.1502 3.37996C14.5402 3.57996 15.0102 3.50996 15.3202 3.19996C15.8002 2.71996 15.6802 1.90996 15.0802 1.59996C14.8102 1.47996 14.5402 1.34996 14.2702 1.23996Z",
    fill: "#27BAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeStyleIcon);
export default __webpack_public_path__ + "static/media/LifeStyleIcon.1065e6e17b419a9cc2ca4a78964fd3e6.svg";
export { ForwardRef as ReactComponent };